<template>
  <div>
    <div class="row mt-5 mb-5">
    <div class="col center-all">
      <div class="w-100 center-all text-center ">
        <h5>מי שמסופק האם יספיק לקרוא קריאת שמע בזמנה בברכותיה יקרא קריאת שמע בזמנה לפני התפילה ויתנה שבמידה ויספיק ק"ש בברכותיה בזמנה יצא בקריאה זו ולא בקריאה שקרא לפני התפילה </h5>
      </div>
      <div class="w-100 center-all text-center ">
        <h1>שְׁמַע יִשְׂרָאֵל יְהוָה אֱלֹהֵינוּ יְהוָה אֶחָד</h1>
      </div>
      <div class="w-100 center-all text-center">
        <h4>(בלחש:) ברוך שם כבוד מלכותו לעולם ועד</h4>

      </div>
      <div class="width-parasha center-all mt-2 mb-2 ">
        <h3>וְאָהַבְתָּ אֵת יְהֹוָה אֱלהֶיךָ. בְּכָל לְבָבְךָ וּבְכָל נַפְשְׁךָ וּבְכָל מְאדֶךָ: וְהָיוּ הַדְּבָרִים
          הָאֵלֶּה אֲשֶׁר אָנכִי מְצַוְּךָ הַיּום עַל לְבָבֶךָ: וְשִׁנַּנְתָּם לְבָנֶיךָ וְדִבַּרְתָּ בָּם.
          בְּשִׁבְתְּךָ בְּבֵיתֶךָ וּבְלֶכְתְּךָ בַדֶּרֶךְ וּבְשָׁכְבְּךָ וּבְקוּמֶךָ: וּקְשַׁרְתָּם לְאות עַל יָדֶךָ.
          וְהָיוּ לְטטָפת בֵּין עֵינֶיךָ: וּכְתַבְתָּם עַל מְזֻזות בֵּיתֶךָ וּבִשְׁעָרֶיךָ:</h3>
      </div>
      <div class="width-parasha center-all mt-2 mb-2 ">
        <h3>וְהָיָה אִם שָׁמעַ תִּשְׁמְעוּ אֶל מִצְותַי אֲשֶׁר אָנכִי מְצַוֶּה אֶתְכֶם הַיּום. לְאַהֲבָה אֶת יְהֹוָה
          אֱלהֵיכֶם וּלְעָבְדו בְּכָל לְבַבְכֶם וּבְכָל נַפְשְׁכֶם: וְנָתַתִּי מְטַר אַרְצְכֶם בְּעִתּו יורֶה
          וּמַלְקושׁ. וְאָסַפְתָּ דְגָנֶךָ וְתִירשְׁךָ וְיִצְהָרֶךָ: וְנָתַתִּי עֵשֶׂב בְּשָׂדְךָ לִבְהֶמְתֶּךָ.
          וְאָכַלְתָּ וְשָׂבָעְתָּ: הִשָּׁמְרוּ לָכֶם פֶּן יִפְתֶּה לְבַבְכֶם. וְסַרְתֶּם וַעֲבַדְתֶּם אֱלהִים אֲחֵרִים
          וְהִשְׁתַּחֲוִיתֶם לָהֶם: וְחָרָה אַף יְהֹוָה בָּכֶם וְעָצַר אֶת הַשָּׁמַיִם וְלא יִהְיֶה מָטָר וְהָאֲדָמָה לא
          תִתֵּן אֶת יְבוּלָהּ. וַאֲבַדְתֶּם מְהֵרָה מֵעַל הָאָרֶץ הַטּבָה אֲשֶׁר יְהֹוָה נתֵן לָכֶם: וְשַׂמְתֶּם אֶת
          דְּבָרַי אֵלֶּה עַל לְבַבְכֶם וְעַל נַפְשְׁכֶם. וּקְשַׁרְתֶּם אתָם לְאות עַל יֶדְכֶם וְהָיוּ לְטוטָפת בֵּין
          עֵינֵיכֶם: וְלִמַּדְתֶּם אתָם אֶת בְּנֵיכֶם לְדַבֵּר בָּם. בְּשִׁבְתְּךָ בְּבֵיתֶךָ וּבְלֶכְתְּךָ בַדֶּרֶךְ
          וּבְשָׁכְבְּךָ וּבְקוּמֶךָ: וּכְתַבְתָּם עַל מְזוּזות בֵּיתֶךָ וּבִשְׁעָרֶיךָ: לְמַעַן יִרְבּוּ יְמֵיכֶם
          וִימֵי בְנֵיכֶם עַל הָאֲדָמָה אֲשֶׁר נִשְׁבַּע יְהֹוָה לַאֲבתֵיכֶם לָתֵת לָהֶם. כִּימֵי הַשָּׁמַיִם עַל
          הָאָרֶץ:</h3>
      </div>
      <div class="width-parasha center-all mt-2 mb-2 ">
        <h3>וַיּאמֶר יְהֹוָה אֶל משֶׁה לֵּאמר: דַּבֵּר אֶל בְּנֵי יִשְׂרָאֵל וְאָמַרְתָּ אֲלֵהֶם וְעָשׂוּ לָהֶם צִיצִת
          עַל כַּנְפֵי בִגְדֵיהֶם לְדרתָם. וְנָתְנוּ עַל צִיצִת הַכָּנָף פְּתִיל תְּכֵלֶת: וְהָיָה לָכֶם לְצִיצִת
          וּרְאִיתֶם אתו וּזְכַרְתֶּם אֶת כָּל מִצְות יְהֹוָה וַעֲשִׂיתֶם אתָם. וְלא תָתוּרוּ אַחֲרֵי לְבַבְכֶם
          וְאַחֲרֵי עֵינֵיכֶם אֲשֶׁר אַתֶּם זנִים אַחֲרֵיהֶם: לְמַעַן תִּזְכְּרוּ וַעֲשִׂיתֶם אֶת כָּל מִצְותָי.
          וִהְיִיתֶם קְדשִׁים לֵאלהֵיכֶם: אֲנִי יְהֹוָה אֱלהֵיכֶם אֲשֶׁר הוצֵאתִי אֶתְכֶם מֵאֶרֶץ מִצְרַיִם לִהְיות
          לָכֶם לֵאלהִים. אֲנִי יְהֹוָה אֱלהֵיכֶם: אֱמֶת:</h3>
      </div>
    </div>
  </div>
      <dayTime />
  </div>

</template>

<script>
  // @ is an alias to /src
  import dayTime from '@/components/dayTime.vue'


  export default {
    name: "Shema",
    components: {
dayTime
    },
    data() {
      return {};
    },
    computed: {

    }
  };
</script>

<style scoped>
  .width-parasha {
    width: 75%;
  }

  @media (max-width: 767.98px) {
    .width-parasha {
      width: 100%;
    }
  }
</style>